import { useEffect, useReducer, useState, useCallback } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import {
  Circle as CircleIcon,
  RadioButtonUnchecked as OfflineIcon,
  Block as UnavailableIcon,
} from "@mui/icons-material";

import api from "../../../api";
import { getSession } from "../../../auth";
import ContactsAutocomplete from "../ContactsAutocomplete";
import { useTelephony } from "../../../contexts/TelephonyContext";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const defaultReducer = (state, action) => {
  return { ...state, ...action };
};


const TransferPanel = ({ open, onClose, onAttendedTransferStarted }) => {
  const [searchValue, setSearchValue] = useState("");
  const [transferType, setTransferType] = useState("btxfer");
  const { sendDTMF } = useTelephony();
  const handleTransferClick = () => {
    console.log("Transfer clicked");
    // Filter out non numeric characters from the search value
    const numberToTransfer = searchValue;
    console.log("Transfer number after filtering:", numberToTransfer);

    const dtmf = `*${transferType === 'atxfer' ? '6' : '7'}${numberToTransfer}`;
		sendDTMF(dtmf);
    if (transferType === 'atxfer' && typeof onAttendedTransferStarted === 'function') {
      onAttendedTransferStarted();
    }
    onClose();
  }
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Transferir</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "80%", margin: "0 auto" }}>
          <ContactsAutocomplete
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleEnterAction={() => {
              console.log("Enter pressed with value:", searchValue);
            }}
            includeCRM={false}
          />
          <FormControl>
            <RadioGroup
              row
              name="row-radio-buttons-group"
              value={transferType}
              onChange={(event) => setTransferType(event.target.value)}
            >
              <FormControlLabel
                value="btxfer"
                control={<Radio />}
                label="Direta"
              />
              <FormControlLabel
                value="atxfer"
                control={<Radio />}
                label="Assistida"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="contained" onClick={onClose}>
          Cancelar
        </Button>
        <Button color="success" variant="contained" onClick={handleTransferClick}>
          Transferir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferPanel;
